<template>
  <div class="policies">
    <div class="table">
      <div class="table__header box box--default">
        <div class="table__label table__label--medium">
          {{ $t(`pendenciesTable.${"pendencyNr"}`) }}
        </div>
        <div class="table__label table__label--medium table__label--fixed">
          {{ $t(`pendenciesTable.${"status"}`) }}
        </div>
        <div class="table__label table__label--large">{{ $t(`pendenciesTable.${"policyNr"}`) }}</div>
        <div class="table__label table__label--large">{{ $t(`pendenciesTable.${"issuanceDate"}`) }}</div>
        <div class="table__label table__label--large">{{ $t(`pendenciesTable.${"insurer"}`) }}</div>
        <div class="table__label table__label--large">{{ $t(`pendenciesTable.${"industry"}`) }}</div>
        <div class="table__label table__label--medium">{{ $t(`pendenciesTable.${"responsible"}`) }}</div>
        <div class="table__label table__label--medium table__label--more-horizontal table__label--last"></div>
      </div> 
      <Loading v-if="detailsLoading || pendenciesLoading" />
      <div v-else class="table__body">
        <div v-if="!computedPendencies.length" class="table__no-data">
          <NoData :type="'pendencies'" />
        </div>

        <div v-else class="table__policies">
          <Pendency v-for="pendency in computedPendencies" :key="pendency.id" :statuses="statuses" :agents="agents"
            :pendency="pendency" :expandedPendencyId="expandedPendencyId" :offer="pendency.customerPolicyOffers" />
        </div>
      </div>

      <!-- <Pagination
        :limit="3"
      :data="usersPerPage"
      @pagination-change-page="getResults"
    ></Pagination> -->
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import Pendency from "@/components/AccountDetails/Pendency";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";

defineOptions({
  name: "PendenciesTable"
});

const {expandedPendencyId} = defineProps({
  expandedPendencyId: {
    required: false,
    type: Number,
  }
});

const store = useStore();

// State
const detailsLoading = ref(false);
//const pendencies = ref([]);
const lastFetchedCustomerId = ref(null);
const teamId = ref(null);

// Computed
const pendencyForms = computed(() => store.getters.pendencyForms);
const customerDetails = computed(() => store.getters.customerDetails);
const computedPendencies = computed(() => store.getters.pendencies);
const pendenciesLoading = computed(() => store.getters.pendenciesLoading);
const statuses = computed(() => pendencyForms.value.statuses || []);
const agents = computed(() => pendencyForms.value.agents || []);
const costumerId = computed(() => store.getters.customerDetailsId);

// Methods
const fetchPendencies = async () => {
  if (!costumerId.value) return;
  if (lastFetchedCustomerId.value === costumerId.value) return;

  detailsLoading.value = true;
  try {
    if (customerDetails.value?.team) {
      teamId.value = Number(customerDetails.value.team.id);
      await store.dispatch("getPendencyForms", teamId.value);
    }
    await store.dispatch("getPendencies", costumerId.value);
    lastFetchedCustomerId.value = costumerId.value;
  } catch (error) {
    console.error(error);
  } finally {
    detailsLoading.value = false;
  }
};

// Watchers
watch(costumerId, (newId, oldId) => {
  if (newId && newId !== oldId) {
    fetchPendencies();
  }
});

watch(
  () => customerDetails.value?.team,
  (newTeam, oldTeam) => {
    if (newTeam && newTeam !== oldTeam) {
      fetchPendencies();
    }
  }
);

// Lifecycle
onMounted(async () => {
  await fetchPendencies();
});
</script>
<style scoped>
.loading { 
  height: 76vh;  
}
</style>